import * as THREE from "three";
import { GLASS_PARAMS } from "./GlassDefeault";
import { applyRadiusColor } from "./RadiusColor";

// 誤り4: グラスの上部（飲み口）だけを丸く（開きすぎて）描く誤り
// グラスのシルエットは直立のまま、一定ラインより上の頂点を高さに比例して
// y += shearValue * z でせん断し、飲み口の楕円面だけを手前に倒して円に近づける。
// model7（グラス全体がx方向へ傾く）との違い：本モデルは胴体が傾かず飲み口だけ開く。
// 単一ジオメトリなので継ぎ目が出ず、モチーフ（Glass.js）と同じ頂点カラー方式で着色できる。
// shearValue: 0=モチーフと一致, 0.2=中間, 0.5=誤り（飲み口の傾き atan(0.5)≈26.6度）
export function createGlass4_1(shearValue, topColor, bottomColor) {
  shearValue = shearValue !== undefined ? shearValue : 0.5;
  const group = new THREE.Group();
  const scaleFactor = GLASS_PARAMS.scaleFactor;

  // 曲げ変形を滑らかに表現するため heightSegments を増やす
  const glassGeometry = new THREE.CylinderGeometry(
    GLASS_PARAMS.glass.topRadius * scaleFactor,
    GLASS_PARAMS.glass.bottomRadius * scaleFactor,
    GLASS_PARAMS.glass.height * scaleFactor,
    GLASS_PARAMS.glass.radialSegments,
    16,
    GLASS_PARAMS.glass.openEnded
  );

  const halfHeight = (GLASS_PARAMS.glass.height * 2 / 3) * scaleFactor;
  const pos = glassGeometry.getAttribute("position");
  for (let i = 0; i < pos.count; i++) {
    const y = pos.getY(i);
    if (y > 0) {
      // 上端で y += shearValue * z（飲み口の楕円面が傾く）、中央に向かって0へ漸減
      pos.setY(i, y + shearValue * pos.getZ(i) * (y / halfHeight));
    }
  }
  pos.needsUpdate = true;
  glassGeometry.computeVertexNormals();

  applyRadiusColor(glassGeometry, topColor, bottomColor, GLASS_PARAMS.glass.color);

  const glassMaterial = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    shininess: GLASS_PARAMS.glass.shininess,
    vertexColors: true,
  });
  const glassMesh = new THREE.Mesh(glassGeometry, glassMaterial);
  glassMesh.position.y = (GLASS_PARAMS.glass.height / 2) * scaleFactor;
  group.add(glassMesh);

  // 環境光とスポットライトを追加してリアルに照らす
  const ambientLight = new THREE.AmbientLight(
    GLASS_PARAMS.light.ambient.color,
    GLASS_PARAMS.light.ambient.intensity
  );
  const spotLight = new THREE.SpotLight(
    GLASS_PARAMS.light.spot.color,
    GLASS_PARAMS.light.spot.intensity
  );
  spotLight.position.set(
    ...GLASS_PARAMS.light.spot.position.map(v => v * scaleFactor)
  );
  spotLight.castShadow = true;
  group.add(ambientLight);
  group.add(spotLight);

  return group;
}
